import React, { ElementType } from 'react';
import Markdown from 'react-markdown';
import './StyledMarkDown.scss';

interface StyledMarkDownProps {
  description?: string;
  renderers?: { [nodeType: string]: ElementType };
}

const StyledMarkDown: React.FC<StyledMarkDownProps> = ({ description = '', renderers }) => (
  <Markdown className="lesson-markdown near-black source-sans lh-copy f6 mw7" renderers={renderers}>
    {description}
  </Markdown>
);

export default StyledMarkDown;
